import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCheckmark2"><Path fillRule="evenodd" clipRule="evenodd" d="M22.8454 3.91943L9.59138 22.1416L1.14377 15.5027L2.99749 13.1439L8.99686 17.8588L20.4193 2.15479L22.8454 3.91943Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark2;
